import React from "react";
import FullpageSpinner from "../modules/spinner/FullpageSpinner";

const ListOverviewTemplate = ({ addCallback, isLoading = false, children, addButtonText }) => {
	return (
		<>
			{isLoading ? (
				<FullpageSpinner />
			) : (
				<>
					{children}
					{addCallback && (
						<div className="row">
							<div className="col-12">
								<button
									type="button"
									className="add-button btn btn-cta center btn-lg float-right mr-3"
									onClick={addCallback}
								>
									<i className="icon">
									</i>{addButtonText}
								</button>
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default ListOverviewTemplate;
